export enum TemplateType {
  'TASK_TEMPLATE' = 'TASK_TEMPLATE',
  'WORKFLOW' = 'WORKFLOW',
  'ACTIVITY_TEMPLATE' = 'ACTIVITY_TEMPLATE',
}
